import React from "react";
import ApproveButton from "@components/FlowActionButtons/ApproveButton";
import type { Task } from "@services/vesselCall/types";
import { canUserApprove } from "../utils";

interface ApproveVesselCallProps {
  vesselCallFlowData?: {
    vesselCallId: string;
    task: Task | null;
    status: string;
  };
  openDrawer: (drawerName: string) => void;
  refetchVesselCall: () => void;
}

const LANG_BASE = "vessel-call.vessel-call-status-header";

const ApproveVesselCall: React.FC<ApproveVesselCallProps> = ({
  vesselCallFlowData,
  openDrawer,
  refetchVesselCall,
}) => {
  if (!vesselCallFlowData || !vesselCallFlowData.task) {
    return null;
  }

  const isActionAvailable = canUserApprove(
    vesselCallFlowData.task.status,
    vesselCallFlowData.task.claimOwnerName,
    vesselCallFlowData.status,
  );

  const handleApproveClick = () => {
    refetchVesselCall();
    openDrawer("approveDrawer");
  };
  return (
    <ApproveButton
      langBase={LANG_BASE}
      permission="canApproveVesselCall"
      isActionAvailable={isActionAvailable}
      onApprove={handleApproveClick}
    />
  );
};
export default ApproveVesselCall;
